export default "__VITE_ASSET__dE1EUoUG__"